import {
  Box,
  GridLegacy as Grid,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import React from 'react';

import { theme as appTheme } from '../../theme/theme';

interface OwnProps {
  featured?: boolean;
  children: React.ReactNode;
  heading: string;
  icon?: React.ReactElement;
  'data-cy'?: string;
}

const HomePageCard: React.FC<OwnProps> = (props) => {
  const { featured = false, children, heading, icon, ...rest } = props;

  return (
    <Box
      sx={{
        backgroundColor: featured ? '#fff' : 'unset',
        padding: { xs: '10px 20px', sm: '20px 0px 0' },
        margin: { xs: '10px 20px', sm: '0px 0px 16px' },
        borderRadius: '30px',
      }}
      data-cy={rest['data-cy']}
    >
      <Grid item xs={12} mt={4} mb={4} id="all-boats-heading">
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ marginBottom: '1.6em !important' }}
        >
          {icon && (
            <SvgIcon sx={{ color: appTheme.palette.primary.main }}>
              {icon}
            </SvgIcon>
          )}
          <Typography
            variant="h2"
            align="left"
            sx={{
              color: appTheme.palette.primary.main,
              fontSize: { xs: '1.7rem', sm: '2rem' },
              lineHeight: '1.2',
              fontWeight: '500',
            }}
          >
            {heading}
          </Typography>
        </Stack>
      </Grid>
      <Grid container spacing={{ xs: 2, sm: 4 }}>
        {children}
      </Grid>
    </Box>
  );
};

export default HomePageCard;
